var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "who-has-access" },
    [
      _c("span", {
        staticClass: "icon icon-loading",
        class: { hidden: !_vm.isLoading }
      }),
      _vm._v(" "),
      _c("span", { class: { hidden: !_vm.isEmptyList } }, [
        _vm._v("\n\t\t" + _vm._s(_vm.emptyLabel) + "\n\t")
      ]),
      _vm._v(" "),
      _vm._l(_vm.uniqueShareUIDs, function(uid) {
        return _c("avatar", {
          key: uid,
          attrs: {
            user: uid,
            "display-name": _vm.uidDisplaynameMap[uid],
            size: 64
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }